<template>
  <div>
    <b-button type="is-dark" v-on:click="edit = true">Produktionsverfahren</b-button>

    <b-modal :active.sync="edit" has-modal-card>
       <div class="modal-card produktionsverfahren" style="width: auto">
        <header class="modal-card-head">
                <p class="modal-card-title">Produktionsverfahren bearbeiten</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div v-for="number in 4" class="column" style="text-align:left;">

              <h6 class="title is-6">Produktionsverfahren {{number}}</h6>

              <div v-if="addonProductions.length < number">
                <b-button
                   icon-left="plus-circle" v-on:click="addProduction(number)">
                   Hinzufügen
               </b-button>
              </div>

              <div v-if="addonProductions.length >= number">
              <b-field label="Hersteller">
                <multiselect class="is-small" v-model="addonProductions[number-1].producer" :show-labels="false" placeholder="Hersteller auswählen" :options="allproducer" :multiple="false" track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>
              <b-field  label="Produktionszeit">
                <b-numberinput size="is-small" v-model="addonProductions[number-1].productiontime"></b-numberinput>
              </b-field>
<!--              <b-field label="Link Preisliste">
                <b-input maxlength="255" size="is-small" v-model="addonProductions[number-1].producerPricelistURL"></b-input>
              </b-field>
              <b-field label="Link Druckvorgaben">
                <b-input maxlength="255" size="is-small" v-model="addonProductions[number-1].printGuidelineURL"></b-input>
              </b-field>-->
              <b-field label="Zoho-Code">
                <b-input maxlength="255" size="is-small" v-model="addonProductions[number-1].zohoCode" readonly="true"></b-input>
              </b-field>
            <!--  <b-field label="Sonderinfo">
                <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].specialInformation"></b-input>
              </b-field>-->
            <!--  <b-field label="Bild">
                <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].image"></b-input>
              </b-field>
              <b-field label="Code">
                <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].code"></b-input>
              </b-field>-->

              <!--<b-field label="Aufschlagsatzstaffel">
                <multiselect class="is-small" v-model="packageProductions[number-1].extraCharge" :show-labels="false" placeholder="Aufschlagsatzstaffel auswählen" :options="allextracharge" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
              </b-field>-->

              <label class="label">Kosten nach Auflage</label>
              <div style="overflow: auto">
                <b-field v-for="(item, index) in addonProductions[number-1].addonCharge" v-if="index != 'id'" :message="index">
                   <b-input pattern="[+]?[0-9]*\.?[0-9]+" size="is-small" v-model="addonProductions[number-1].addonCharge[index]"></b-input>
               </b-field>
              </div>




              <!--<label class="label">ExtraCharge</label>
              <div style="max-height: 170px;overflow: auto">
                <b-field v-for="(item, index) in packageProductions[number-1].extraCharge" v-if="index != 'id'" :message="index">
                   <b-numberinput size="is-small" v-model="packageProductions[number-1].extraCharge[index]"></b-numberinput>
               </b-field>
             </div>-->

             <div style="margin-top:20px;">
               <b-button
                  icon-left="minus-circle" v-on:click="removeProduction(number)">
                  Entfernen
              </b-button>
             </div>
            </div>
            </div>
          </div>

        </section>


        <footer class="modal-card-foot">
                <b-button class="button is-primary" @click="saveAllAddonProduction">Übernehmen</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
const axios = require('axios');

import Multiselect from 'vue-multiselect'

    export default {
      props: ['selected'],
      components: {
	       Multiselect
    	},
        data(){
          return {
            edit: false,
            //packageProductions: [],
            addonProductions: [],
            allproducer: [],
          }
        },
        watch: {
          selected(val) {
              this.addonProductions = val;
              this.prepareProductionsArray();
              console.log("TEST");
              console.log(this.addonProductions);
          },
          addonProductions(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          this.getProducer();
        //  this.getExtraCharge();
        },
        methods: {
          getProducer: function() {
            var _this = this;
            axios.get('/api/producers', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log("PRODUCER");
              console.log(response.data);
              _this.allproducer = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          },
          prepareProductionsArray: function() {
            console.log("JSON");

            if (this.addonProductions.length == 1) {
              //this.packageProductions.push( empyGameProduction );
            }

          },
          addProduction: function(number) {
            console.log("Add "+number);
            //var newGameProd = Object.assign({}, empyGameProduction);
              var newAddonProd = _.cloneDeep(emptyAddonProduction);
              //Producer 1 als standard setzen
            newAddonProd.producer = this.allproducer[0];
              //Extra CHarge 1 als standard setzen
            //  newPackageProd.extraCharge = this.allextracharge[0];
          //  this.packageProduc[0] = empyGameProduction;
            this.addonProductions.push(newAddonProd);
          },
          removeProduction: function(number) {
            console.log("Remove "+number);
            this.addonProductions.splice(number-1, 1);
        //    this.gameProductions.push(newGameProd);
          },
          saveAllAddonProduction: function() {
            console.log(this.addonProductions);
            //Preise: Komma durch Punkt ersetzen
          /*  this.packageProductions.forEach(function(el,index,arr){
               console.log(arr);
               console.log(el.packageCharge);

               Object.keys(el.packageCharge).forEach(function(key) {

                console.log(key, el.packageCharge[key]);
                el.packageCharge[key] = el.packageCharge[key];
              });

            });*/
            console.log(this.addonProductions);

            this.$emit('input', this.addonProductions);
            this.edit = false;
          }
        },
      }

      const emptyAddonProduction =
          {
        addonCharge: {
        //  id: 0,
          pac100: null,
          pac150: null,
          pac200: null,
          pac250: null,
          pac300: null,
          pac400: null,
          pac500: null,
          pac750: null,
          pac1000: null,
          pac1500: null,
          pac2000: null,
          pac2500: null,
          pac3000: null,
          pac4000: null,
          pac5000: null,
          pac7500: null,
          pac10000: null,
          pac15000: null,
          pac20000: null,
          pac30000: null,
          pac50000: null,
          pac100000: null
        },
        productiontime: 0,
        producerPricelistURL: "string",
        printGuidelineURL: "string"
      //  specialInformation: "string"
      //  image: "string",
      //  code: "string"
        }
        ;
</script>
<style lang="scss">
.produktionsverfahren .label {
    font-size: 14px;
  }
.multiselect.is-small {
      min-height: 27px;
          font-size: 0.75rem;
              color: #363636;
}
.multiselect.is-small  .multiselect__select {
    position: absolute;
    width: 40px;
    height: 27px;
  }
.multiselect.is-small  .multiselect__tags {
    min-height: 27px;
    display: block;
    padding: 4px 40px 0 4px;
  }
  .multiselect.is-small  .multiselect__input,
  .multiselect.is-small  .multiselect__single {
      font-size: 0.75rem;
      margin-bottom: 3px;
  }

</style>
